import { getRoot } from 'mobx-easy';

import RootStore from 'bringg-web/stores/root-store';
import { FiltersObject } from '../types';
import { View } from '../../../types';

const userFilters: Map<string, FiltersObject> = new Map();

const getStorageKey = (view: View) => {
	const { id, merchant_id } = getRoot<RootStore>().data.usersStore.currentUser;

	return `monitoring-filters-${view}-${merchant_id}-${id}`;
};

const getUserMonitoringFilters = (storageKey: string) => {
	if (!userFilters.has(storageKey)) {
		userFilters.set(storageKey, (JSON.parse(localStorage.getItem(storageKey)) as FiltersObject) || {});
	}

	return userFilters.get(storageKey);
};

const saveUserMonitoringFilters = (storageKey: string, filtersObject: FiltersObject) => {
	localStorage.setItem(storageKey, JSON.stringify(filtersObject));
	// check if the column config aldo need this setter
	userFilters.set(storageKey, filtersObject);
};

const clearUserMonitoringFilters = () => {
	userFilters.clear();
};

export const userFiltersProvider = {
	getStorageKey,
	getUserMonitoringFilters,
	saveUserMonitoringFilters,
	clearUserMonitoringFilters
};
